import { VariableType } from 'json-to-graphql-query';

import { Profile } from '@/interfaces/profile';
import { EntityResource } from './entity.resource';

/**
 * Resource profili
 *
 * @export
 * @class ProfileResource
 * @extends {EntityResource<Profile>}
 */
export class ProfileResource extends EntityResource<Profile> {
  public getVariables = { id: 'Int' };

  public getFields = {
    id: true,
    email: true,
    firstName: true,
    lastName: true,
    pesel: true,
    address: true,
    externalId: true,
    data: true
  };

  public listFields = {
    id: true,
    email: true,
    firstName: true,
    lastName: true
  };

  constructor() {
    super({
      entityName: 'profile'
    });
  }

  /**
   * Pobiera węzły struktury sekretarki
   *
   * @returns
   * @memberof ProfileResource
   */
  public getSecretaryNodes() {
    const query = this.prepareOptions({
      query: {
        profileStructuresGet: {
          id: true,
          name: true,
          type: true,
          typeDescription: true,
          isGuided: true,
          isSchool: true,
          isCollege: true,
          isSingle: true,
          data: true,
          parentId: true,
          childrenIds: true,
          externalUid: true,
          bankAccountNumber: true
        }
      }
    });
    return this.query({ query }, 'profileStructuresGet');
  }

  /**
   * Ustawia dane wnioskodawcy
   *
   * @param {*} variables
   * @returns {Promise<number>}
   * @memberof ProfileResource
   */
  public setApplicantData(variables: any): Promise<number> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: {
          profileId: 'Int!',
          applicantData: 'JSON!'
        },
        setApplicantData: {
          __args: {
            profileId: new VariableType('profileId'),
            applicantData: new VariableType('applicantData')
          }
        }
      }
    });
    return this.mutation({ mutation, variables }, 'setApplicantData');
  }
}

export const profileResource = new ProfileResource();
